module.exports = " <div v-if=\"circles.length > 0\" class=swiper-pagination> <span v-for=\"($index, c) in circles\" class=circle :style=\"{\n          'backgroundColor': activeIndex == $index ? pagerColor : pagerBgColor,\n          'opacity': (pagerColor == pagerBgColor) ? (activeIndex == $index ? '1' : '0.4') : '1'\n        }\"></span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/swiper/SwiperPagination.vue
// module id = 245
// module chunks = 0